module.exports = __webpack_public_path__ + "img/star.dac2c641.svg";